import axios from "@/libs/api.request";

export const getTableData = () => {
  return axios.request({
    url: "get_table_data",
    method: "get"
  });
};

export const getDragList = () => {
  return axios.request({
    url: "get_drag_list",
    method: "get"
  });
};

export const errorReq = () => {
  return axios.request({
    url: "error_url",
    method: "post"
  });
};

export const saveErrorLogger = info => {
  return axios.request({
    url: "save_error_logger",
    data: info,
    method: "post"
  });
};

export const uploadImg = formData => {
  return axios.request({
    url: "image/upload",
    data: formData
  });
};

export const getOrgData = () => {
  return axios.request({
    url: "get_org_data",
    method: "get"
  });
};

export const getTreeSelectData = () => {
  return axios.request({
    url: "get_tree_select_data",
    method: "get"
  });
};

export const getMobile = data => {
  console.log("收到的数据：", data);
  return axios.request({
    url: "caiji/?s=mobile.getInfo",
    data: data,
    method: "POST"
  });
};
export const saveMobile = data => {
  console.log("收到的数据：", data);
  return axios.request({
    url: "caiji/?s=mobile.saveMobile",
    data: data,
    method: "POST"
  });
};

export const getFixList = params => {
  console.log("收到的数据：", params);
  return axios.request({
    url: "caiji/?s=mobile.getFixList",
    params,
    method: "GET"
  });
};

export const check58Call58 = () => {
  return axios.request({
    url: "caiji/?s=get58User.getData",
    method: "GET"
  });
};
